import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { Logo } from '@/components/Logo';

/**
 * Route wrapper for auth pages (login, register, etc.)
 * Redirects to /games if user is already logged in
 * Provides the auth layout with centered card and logo
 */
export function AuthRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-neutral-500" />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/games" replace />;
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo/Title */}
        <div className="flex flex-col items-center mb-8">
          <Logo />
        </div>

        {/* Auth Card */}
        <div className="bg-neutral-950 border border-neutral-800 rounded-lg p-6">
          <Outlet />
        </div>

        {/* Footer */}
        <p className="text-center text-neutral-600 text-xs mt-6">
          Every wish casts a shadow.
        </p>
      </div>
    </div>
  );
}
